import React from 'react';

const SubscriptionCostField = ({ value, data, ...props }) => {
  if (!value) return <>-</>;

  return <>€ {value} / anno</>;
};

export default SubscriptionCostField;
